import React from 'react'
import WebdevlopmentBanner from '../components/webdevlopmentBanner'
import ReactTexhnology from '../components/TechnologyWeb'
import AngularTechnology from '../components/AngularTechnology'
import NextjsTechnology from '../components/NextjsTechnology'
import VueTechnology from '../components/VueTechnology'

const WebdevlopmentPage = () => {
  return (
    <>
    <WebdevlopmentBanner />
    <ReactTexhnology />
    <AngularTechnology />
    <NextjsTechnology/>
    <VueTechnology />
    </>
  )
}

export default WebdevlopmentPage
